import { Component, ViewChild, ViewContainerRef, AfterViewInit } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { TypoComponent } from '../typo/typo.component';
import { IconComponent } from '../icon/icon.component';
import { ConfirmService } from './services/confirm.service';
import { IConfirmOptions } from './interfaces/confirm-options.interface';
import { ButtonComponent } from '../../forms/components/button/button.component';
import { Type } from '../../forms/components/button/types/button-type.type';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'berry-confirm',
    standalone: true,
    imports: [CommonModule, TypoComponent, IconComponent, ButtonComponent, TranslateModule],
    templateUrl: './confirm.component.html',
    styleUrl: './confirm.component.scss',
})
export class ConfirmComponent implements AfterViewInit, IConfirmOptions {

  @ViewChild('template', { read: ViewContainerRef }) template!: any;

  options: any;
  constructor(public dialogRef: MatDialogRef<ConfirmComponent>, private confirmService: ConfirmService) {
    this.options = this.confirmService.confirmOptions;
  }

  public get getSubmitButtonColor(): Type {
    switch (this.confirmService.confirmationBoxType) {
      case "Danger":
        return 'danger'
      case "Info":
            return 'primary';
      case "Success":
        return 'success';
      case "Warning":
        return 'warning';
      default:
        return 'info'
    }
  }

  onClose() {
    this.dialogRef.close()
  }

  dismiss(): void {
    this.options.confirmationBoxResultEnum = false;
    this.dialogRef.close()
  }

  submit(): void {
    this.options.confirmationBoxResultEnum = true;
    this.dialogRef.close();
  }

  public get title(): string {
    return this.options.title;
  }

  public get subTitle(): string {
    return this.options.subTitle;
  }

  public get submitButtonText(): string {
    return this.options.submitButtonText;
  }

  public get closeButtonText(): string {
    return this.options.closeButtonText;
  }

  ngAfterViewInit(): void { }
}
